import React, { Component, Fragment } from 'react';
import Navbar from 'react-bootstrap/Navbar';
import './header.css';

class Header extends Component {

  constructor(props) {
    super(props);
    console.log(props);
    this.state = {};
  }

  render() {
    return (
      <Fragment>
        <Navbar variant="dark" className="haartHeader">
          <Navbar.Brand style={{ width: '100%' }}>
            <div style={{ display: 'inline-flex' }}>
              <img className="haartHeaderImage" src={require("../../assets/images/haart-white.png")}></img>
             </div>
          </Navbar.Brand>
        </Navbar>
      </Fragment>
    );
  }
}

export default Header;